// extracted by mini-css-extract-plugin
export var body = "_cd-0";
export var sectionHeader = "_cd-4";
export var shortcutColumns = "_cd-2";
export var shortcutList = "_cd-1";
export var shortcutSection = "_cd-3";